import { render, staticRenderFns } from "./subTab2.vue?vue&type=template&id=509f6fc0&scoped=true"
import script from "./subTab2.vue?vue&type=script&lang=js"
export * from "./subTab2.vue?vue&type=script&lang=js"
import style0 from "./subTab2.vue?vue&type=style&index=0&id=509f6fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f6fc0",
  null
  
)

export default component.exports